/**
 * Thrown by `withOperationTimeout` when the driver-side cap
 * fires before the wrapped Playwright operation settles. Carries the `label`
 * so callers can discriminate *which* capped operation timed out via
 * `instanceof` + `err.label` rather than matching the error message string
 * (which is refactor-fragile).
 */
export class OperationTimeoutError extends Error {
  readonly label: string;
  readonly timeoutMs: number;

  constructor(label: string, timeoutMs: number) {
    super(`${label} timed out after ${timeoutMs}ms`);
    this.name = 'OperationTimeoutError';
    this.label = label;
    this.timeoutMs = timeoutMs;
  }
}
